import clsx from "clsx";
import { SyntheticEvent } from "react";

import InputDate from "@/components/atoms/inputForms/InputDate";

interface Props {
  onChangeFrom: (
    date: Date | null,
    event: SyntheticEvent<any, Event> | undefined,
  ) => void;
  onChangeTo: (
    date: Date | null,
    event: SyntheticEvent<any, Event> | undefined,
  ) => void;
  label?: string;
  valueFrom?: Date | null;
  valueTo?: Date | null;
  maxDate?: Date | null;
  minDate?: Date | null;
  maxDateFrom?: Date | null;
  minDateFrom?: Date | null;
  maxDateTo?: Date | null;
  minDateTo?: Date | null;
  placeholderFrom?: string;
  placeholderTo?: string;
  containerClassName?: string;
  labelClassName?: string;
  className?: string;
  inputClassName?: string;
  showTimeSelect?: boolean;
  dataTimeFormat?: string;
  disabled?: boolean;
  showMonthYearPicker?: boolean;
}

const DateFieldBetween = ({
  onChangeFrom,
  onChangeTo,
  label,
  valueFrom,
  valueTo,
  maxDate,
  minDate,
  maxDateFrom,
  minDateFrom,
  maxDateTo,
  minDateTo,
  placeholderFrom,
  placeholderTo,
  containerClassName,
  labelClassName = "mb-1 text-xs",
  className = "",
  inputClassName,
  showTimeSelect,
  dataTimeFormat,
  disabled,
  showMonthYearPicker,
}: Props) => {
  const classNames = [className].join(" ");

  return (
    <fieldset className={clsx(`flex flex-col mt-0`, containerClassName)}>
      {label && (
        <label className={clsx("block", labelClassName)}>{label}</label>
      )}
      <div className="flex items-center space-x-2">
        <div className={classNames}>
          <InputDate
            onChange={onChangeFrom}
            selected={valueFrom}
            selectsStart={true}
            startDate={valueFrom}
            endDate={valueTo}
            minDate={minDateFrom ?? minDate}
            maxDate={maxDateFrom ?? maxDate ?? valueTo}
            placeholder={placeholderFrom}
            showTimeSelect={showTimeSelect}
            formatType={dataTimeFormat}
            className={inputClassName}
            disabled={disabled}
            showMonthYearPicker={showMonthYearPicker}
          />
        </div>
        <p>〜</p>
        <div className={classNames}>
          <InputDate
            onChange={onChangeTo}
            selected={valueTo}
            selectsEnd={true}
            startDate={valueFrom}
            endDate={valueTo}
            minDate={minDateTo ?? minDate ?? valueFrom}
            maxDate={maxDateTo ?? maxDate}
            placeholder={placeholderTo}
            showTimeSelect={showTimeSelect}
            formatType={dataTimeFormat}
            className={inputClassName}
            disabled={disabled}
            showMonthYearPicker={showMonthYearPicker}
          />
        </div>
      </div>
    </fieldset>
  );
};

export default DateFieldBetween;
